// inv/src/pages/authentication/LoginPage.jsx
import { useState } from 'react';
import { API_URL } from '../../config';
import { useTranslation } from 'react-i18next';
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import axios from 'axios';
import LoginGoogleButton from './LoginGoogleButton';
import { Mail, Lock } from 'lucide-react';
import { collectGAContext } from '../../service-scripts/gaContext';

const LoginPage = () => {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      const { client_id, attribution } = await collectGAContext();

      const url = client_id
        ? `${API_URL}/login?client_id=${encodeURIComponent(client_id)}`
        : `${API_URL}/login`;

      const response = await axios.post(url, {
        email: email,
        password: password,
        attribution
      }, { withCredentials: true });

      document.cookie = `token=${response.data.token}; path=/`;

      window.location.href = '/app/find-investors';
    } catch (error) {
      console.error('Ошибка при входе в систему:', error);
      if (error.response && error.response.status === 404) {
        alert('Пользователь с таким email не найден');
      } else if (error.response && error.response.status === 400) {
        alert('Неверный пароль');
      } else {
        alert('Ошибка сервера. Попробуйте позже.');
      }
    }
  };

  return (
    <div className="flex container px-12 md:px-12 lg:px-18 mt-8 min-h-[520px]">
      <div className="quote-section2 shadow-lg rounded-md px-12 w-1/3 hidden lg:flex flex-col items-center justify-center bg-gray-100">
        <p className="quote-text">
          "The only thing worse than starting something and failing… is not starting something."</p>
        <p class="quote-author">— Seth Godin, Squidoo founder, author and blogger</p>
      </div>
      <div className="w-full lg:w-1/2 flex flex-col items-center justify-center py-8 mx-auto lg:py-0">
        <div className="w-full bg-white rounded-lg sm:max-w-md xl:p-0">
          <div className="p-2 space-y-4 md:space-y-6 sm:p-8">
            <h2 className="text-left text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl ">
              {t('pageLogin.t1')}
            </h2>
            <form className="space-y-4 md:space-y-6" onSubmit={handleLogin}>
              <div className="flex items-center gap-2">
                <Mail className="w-5 h-5 mr-2" />
                <label htmlFor="email" className="w-1/3 block text-sm font-medium text-gray-900 ">{t('pageLogin.t2')}</label>
                <Input
                  multi={false}
                  className="w-2/3"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  name="email"
                  id="email"
                  placeholder="name@company.com"
                  required
                />
              </div>
              <div className="flex items-center gap-2">
                <Lock className="w-5 h-5 mr-2" />
                <label htmlFor="password" className="w-1/3 block text-sm font-medium text-gray-900 ">{t('pageLogin.t3')}</label>
                <Input
                  multi={false}
                  className="w-2/3"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  name="password"
                  id="password"
                  placeholder="••••••••"
                  required
                />
              </div>
              <Button
                className="min-w-36"
                type="submit"
                variant="secondary"
                size="sm"
              >
                {t('pageLogin.t4')}
              </Button>
              <p className="text-sm font-light text-gray-500">
                {t('pageLogin.t5')} <a
                  href={i18n.language === 'en' ? '/login/forgot-password' : `/${i18n.language}/login/forgot-password`}
                  className="font-medium text-stone-900 hover:underline "
                >
                  {t('pageLogin.t6')}
                </a>
              </p>
            </form>
            <LoginGoogleButton />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
